// @ts-nocheck
import {
  Box,
  Pagination,
  PaginationItem,
  styled,
  useMediaQuery,
} from "@mui/material";
import PropTypes from "prop-types";
import "./dotPagination.css";
import { ArrowBack } from "@mui/icons-material";
import { ArrowForward } from "@mui/icons-material";

const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
  "&.MuiPaginationItem-root": {
    color: theme.palette.common.white,
  },
  "&.Mui-selected": {
    color: theme.palette.secondary.main,
  },
  "&.Mui-disabled": {
    opacity: 0.4,
    pointerEvents: "none",
    color: theme.palette.grey[500],
  },
}));
export default function DotPagination({
  currPage: cp,
  setCurrPage,
  valueLen,
  valueOnPerPage,
  addOne = true,
  disableList = false,
}) {
  const currPage = addOne ? cp + 1 : cp;
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const totalPages = Math.ceil(valueLen / valueOnPerPage) || 0;

  const handlePageChange = (_event, page) => {
    if (disableList?.includes?.(page)) {
      const dir = page > currPage ? 1 : -1;
      let newPage = page;

      // keep skipping in the direction until a valid page is found
      while (
        disableList.includes(newPage) &&
        newPage >= 1 &&
        newPage <= totalPages
      ) {
        newPage += dir;
      }

      // only change page if within valid range
      if (
        newPage >= 1 &&
        newPage <= totalPages &&
        !disableList.includes(newPage)
      ) {
        setCurrPage(addOne ? newPage - 1 : newPage);
      }
    } else {
      setCurrPage(addOne ? page - 1 : page);
    }
  };

  return (
    <Box className="bottomPagination">
      <Box
        sx={{
          "& td": {
            display: "block",
          },
          padding: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "transparent",
        }}
      >
        <Pagination
          count={totalPages}
          page={currPage}
          onChange={handlePageChange}
          siblingCount={isSmallScreen ? 0 : 1}
          renderItem={(item) => {
            const isPage = item.type === "page";
            const isDisabled = isPage && disableList?.includes?.(item.page);

            const isPrevArrow = item.type === "previous";
            const isNextArrow = item.type === "next";

            const disablePrevArrow = isPrevArrow && currPage === 1;
            const disableNextArrow = isNextArrow && currPage === totalPages;

            return (
              <StyledPaginationItem
                component="button"
                slots={{ previous: ArrowBack, next: ArrowForward }}
                {...item}
                disabled={isDisabled || disablePrevArrow || disableNextArrow}
              />
            );
          }}
        />
      </Box>
    </Box>
  );
}

DotPagination.propTypes = {
  currPage: PropTypes.number,
  setCurrPage: PropTypes.func,
  valueLen: PropTypes.number,
  valueOnPerPage: PropTypes.number,
  addOne: PropTypes.bool,
  disableList: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
};